import React from "react";
import { Alert } from "reactstrap";
// const NotAuthorized = () => {
//   // alert("You are not authorized for this.");
//   // window.location.assign("/error_403");
// };

const NotAuthorized = (props) => {
  const { message } = props;
  return (
    <Alert color="danger">
      <b>The following errors prevented further action</b>
      <li>{message}</li>
    </Alert>
  );
};

NotAuthorized.defaultProps = {
  message: "You do not have permission for this page.",
};

export default NotAuthorized;
